import React from 'react'
import About from './About';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CompareGallery from '../../components/Gallery/CompareGallery';
export default function ResultGallery() {

    const galleryData = [
        {
            before: '/images/mask_2.png',
            after: '/images/mask_3.png',
        },
        {
            before: '/images/mask_3.png',
            after: '/images/mask_4.png',
        },
        {
            before: '/images/mask_4.png',
            after: '/images/mask_1.png',
        },
        {
            before: '/images/mask_3.png',
            after: '/images/mask_4.png',
        },
        {
            before: '/images/mask_4.png',
            after: '/images/mask_1.png',
        },
        {
            before: '/images/mask_2.png',
            after: '/images/mask_3.png',
        },
    ];

    return (
        <About>
            <Box overflow={'hidden'}>
                <Box paddingLeft={'10%'} width={'65%'}>
                    <Grid container spacing={3}>
                        <Grid size={12}>
                            <Typography component={'h1'} fontWeight={'bold'} fontSize={'1.5rem'} className='dColor'>
                                Results Gallery
                            </Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography component={'p'} fontSize={'1.125rem'} className='dColor'>
                                Rezultatet tona reflektojnë kombinimin e teknologjisë së avancuar dhe protokolleve të personalizuara.
                                <br /><br />
                                Çdo trajtim është i përshtatur për nevojat individuale, me qëllim përmirësimin gradual të cilësisë së lëkurës dhe mirëqenies tuaj të përgjithshme.
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ marginY: '80px', width: 1, border: 'solid 1px #DBDAD9' }} />
                <Box paddingLeft={'10%'} width={'65%'}>
                    <Grid container>
                        <Grid size={12}>
                            <Box>
                                <CompareGallery imageSet={galleryData} height={{ md: '480px', xs: '300px' }} dontShow={true} />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </About>
    )
}
